import { Component, OnInit } from '@angular/core';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { ContentElement, ContentStatusEnum, GridCell, RowCell, SectionData } from '@urbannex/storethemes';
import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState } from '../../../model';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';
import { take } from 'rxjs';

@Component({
  selector: 'kve-padding-preset-popover',
  templateUrl: './padding-preset-popover.component.html',
  styleUrls: ['./padding-preset-popover.component.scss']
})
export class PaddingPresetPopoverComponent implements OnInit {
  title: string;
  color: string;
  colors: any[];
  content: any;
  /**
   * Element for which the padding is to be set:
   * self, section, cell, content, contentElement,parent
   */
  target: string;
  /**
   * Only used when in multi-mode - i.e. the popover is used to set either border,padding, margin, border-radius.
   * This should be removed as each popover deal with a specific property (separate popovers)
   */
  property: string;
  status: ContentStatusEnum;
  /**
   * The service to be used to update the element - cellEditorStoreService or sectionEditorStoreService
   */
  service: string;
  /**
   * The string to be used in the inline style for the element
   */
  paddingString: string;
  selectedCell: GridCell | RowCell;
  sectionData: SectionData;

  contentElement: ContentElement;
  contentElements: ContentElement[];
  declarationType: string

  value = 1;
  options: Options = {
    floor: 0,
    ceil: 40,
    step: 1
  };

  paddingClasses = [
    { name: "Tiny", class: "kve-pad-tiny", value: "0.3125rem 0.625rem" },
    { name: "Small", class: "kve-pad-small", value: "0.4375rem 0.875rem" },
    { name: "Default", class: "kve-pad-default", value: "0.5rem" },
    { name: "Medium Small", class: "kve-pad-medium-small", value: "0.6875rem 1.125rem" },
    { name: "Medium", class: "kve-pad-medium", value: "0.8125rem 1.125rem" },
    { name: "Medium Large", class: "kve-pad-large-medium", value: "0.9375rem 1.375rem" },
    { name: "Large", class: "kve-pad-large", value: "1.0625rem 1.625rem" },
    { name: "Extra Large", class: "kve-pad-extralarge", value: "1.1875rem 1.875rem" }
  ]

  constructor(private cellEditorStoreService: CellEditorStoreService,
    private sectionEditorStoreService: SectionEditorStoreService,
    private sectionBuilderStoreService: SectionBuilderStoreService) {
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (cell) {
        this.selectedCell = cell;
      }

    })
    this.sectionEditorStoreService.sectionData$.subscribe(sectionData => {
      if (sectionData) {
        this.sectionData = sectionData;
      }
    })
  }

  ngOnInit(): void {
    /**
     * Use the incoming service to set initial values:
     * 1. paddingString
     * 2. contentElement - if the target is contentElement or parent
     *
     *
     */
    if (this.service) {
      console.log(this.service)
      switch (this.service) {
        case "cellEditorStoreService":
          if (!this.selectedCell) return
          if (this.target && (this.target == "content" || this.target == "contentElement" || this.target == "parent")) {
            // Make sure there's a contentElement
            this.cellEditorStoreService.activeSelector$.subscribe((contentElement) => {
              if (contentElement) {
                this.contentElement = contentElement
              } else {
                if (this.selectedCell && this.selectedCell.contentElements) {
                  this.contentElement = this.selectedCell.contentElements[0];
                }
              }
              console.log(this.contentElement);
            })
            if (this.target == "content" || this.target == "contentElement") {
              this.paddingString = this.contentElement.padding ? this.contentElement.padding : "";
            } else if (this.target == "parent") {
              this.paddingString = this.contentElement.parentPadding ? this.contentElement.parentPadding : "";
            }
          } else if (this.target && (this.target == "cell" || this.target == "self")) {
            this.paddingString = this.selectedCell.padding;
          }
          if (this.paddingString == "" || this.paddingString == undefined) {
            this.paddingString = this.createCellPropertyString()
          }
          break;
        case "sectionEditorStoreService":
          if (!this.sectionData) return
          if (this.target == "content" || this.target == "contentElement" || this.target == "title") {
            const title: ContentElement = this.sectionData.title;
            this.paddingString = title.padding
          } else {
            this.paddingString = this.sectionData.padding;
          }
          if (this.paddingString == "" || this.paddingString == undefined) {
            this.paddingString = this.createSectionPropertyString()
          }

          break;
        default:
          break;
      }
      console.log(this.paddingString);

    }
    console.log(this.status)
    if (this.status) {
      switch (this.status) {
        case ContentStatusEnum.CTNT_INITIAL_DRAFT:
          this.service = "sectionBuilder";
          this.sectionBuilderStoreService.updateEditState(EditState.EDITING);
          // this.sectionBuilderStoreService.selectedCell$.subscribe((cell:GridCell | RowCell) => {
          //   let contentElements = cell.contentElements;
          //   this.contentElement = contentElements.find(element => element.elId == this.content.elId);
          // })
          break;
        case ContentStatusEnum.CTNT_FINAL_DRAFT:
          this.service = "cellEditorStoreService";
          // this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
          //   this.contentElement = contentElements.find(element => element.elId == this.content.elId);
          // })
          break;
        default:
          this.service = "cellEditorStoreService"
          break;
      }
    } else {
      this.service = "cellEditorStoreService"
    }
    /* console.log(this.property);
    if(this.property.startsWith("padding")){
      this.declarationType = "padding"
    }else if(this.property.startsWith("margin")){
      this.declarationType = "margin"
    }else if(this.property.startsWith("border")){
      this.declarationType = "border";
    } */
    /* switch (this.property) {
      case "paddingTop":
        this.title = "Padding Top";
        break;
      case "paddingRight":
        this.title = "Padding Right"
        break;
      case "paddingBottom":
        this.title = "Padding Bottom"
        break;
      case "paddingLeft":
        this.title = "Padding Left"
        break;
      case "margin":
        this.title = "Margin Top"
        break;
      case "marginTop":
        this.title = "Margin Top"
        break;
      case "MarginRight":
        this.title = "Margin Right"
        break;
      case "MarginBottom":
        this.title = "Margin Bottom"
        break;
      case "MarginLeft":
        this.title = "Margin Left"
        break;
      default:
        this.title = "Padding"
        break;
    } */
  }

  onPaddingSelect(paddingClass) {
    console.log(paddingClass)
    this.content.padding = paddingClass.value;
    this.content.paddingClass = paddingClass.class;
    if (this.service == "cellEditor") {
      this.cellEditorStoreService.updateActiveSelector(this.content)
    } else if (this.service == "sectionBuilder") {
      console.log("Doing a section builder")
      console.log(this.content);
      this.sectionBuilderStoreService.updateContent(this.content);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)
    }

    /* switch (this.content.selector) {
      case "header":
        this.cellEditorStoreService.updateHdrPadCust(paddingClass.value)
        break;
      case "footer":
        this.cellEditorStoreService.updateFtrPadCust(paddingClass.value)
        break;
      case "banner-text":
        this.cellEditorStoreService.updateTxtPadCust(paddingClass.value)
        break;

      default:
        break;
    } */
  }


  onUserChange(changeContext: ChangeContext) {
    console.log(changeContext.value);
    // this.marginBottom = changeContext.value;
  }
  onUserChangeStart(changeContext: ChangeContext) {
    console.log({ start: changeContext.value })
  }

  onUserChangeEnd(changeContext: ChangeContext) {
    console.log({ end: changeContext.value });
    const value = changeContext.value + "px"
    this.cellEditorStoreService.contentElements$.subscribe((contentElements: ContentElement[]) => {
      const contentElement = contentElements.find(element => element.elId == this.content.elId);
      switch (this.property) {
        case "paddingTop":
          this.title = "Padding Top"
          contentElement.paddingTop = value;
          break;
        case "paddingRight":
          contentElement.paddingRight = value;
          break;
        case "paddingBottom":
          contentElement.paddingBottom = value;
          break;
        case "paddingLeft":
          contentElement.paddingLeft = value;
          break;
        default:
          break;
      }

      this.cellEditorStoreService.updateContentElements(contentElements);
    })
  }

  createCellPropertyString(): string {
    if (this.target == "parent") {
      return "0.5rem";
    }
    return "0rem";
  }

  createSectionPropertyString(): string {
    if (this.target == "content" || this.target == "contentElement" || this.target == "title") {
      return "1rem 0rem"
    }
    return "0rem";
  }


  onPaddingChange(e) {
    console.log({ e: e, service: this.service, target: this.target })
    switch (this.service) {
      case "sectionEditorStoreService":
        this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
          const updatedSectionData: SectionData = { ...sectionData, padding: e }
          this.sectionEditorStoreService.updateSectionData({ ...updatedSectionData })
        })
        break;
      case "cellEditorStoreService":
        console.log("Updating using service: " + this.service)
        switch (this.target) {
          case "self":
          case "cell":
            console.log("updating border for cell")
            this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
              const updatedCell: RowCell | GridCell = { ...cell, border: e }
              console.log("cell-editor-store.service.ts - updating selected cell border: " + updatedCell);
              this.cellEditorStoreService.updateSelectedCell({ ...updatedCell })
            })
            break;
          case "content":
          case "contentElement":
            console.log("updating contentElement with service " + this.service)
            /**
             * Routine to ensure that a contentElement is present.
             */
            let contentElement;
            this.cellEditorStoreService.contentElements$.subscribe(contentElements => {
              if (contentElements) {
                this.contentElements = contentElements;
              }
            })
            this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(content => {
              /**
               * If there is no content element active in the store, check for contentElements and select the first
               * If the are no contentElements in the store, check for selectedCell, get the contentElements and select the first
               */
              if (!content) {
                if (this.contentElements && this.contentElements.length > 0) {
                  contentElement = this.contentElement[0];
                } else {
                  this.cellEditorStoreService.contentElements$.subscribe(contentElements => {
                    contentElement = contentElements[0];
                  })
                }
                if (contentElement == undefined) {
                  this.cellEditorStoreService.selectedCell$.subscribe(cell => {
                    if (cell) {
                      const contentElements = cell.contentElements;
                      if (contentElements && contentElements.length > 0)
                        contentElement = contentElements[0]
                    }
                  })
                }
              } else {
                /**
                 * There is an active contentElement in the store
                 */
                contentElement = Object.assign(content);
              }

              const updatedContent: ContentElement = { ...contentElement, padding: e }
              console.log(updatedContent)
              this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
              /* this.cellEditorStoreService.updateActiveSelector(updatedContent);
              let updatedContentElements:ContentElement[];
              let selectedCell:GridCell | RowCell;
              this.cellEditorStoreService.selectedCell$.subscribe(cell => {
                selectedCell = cell;
                updatedContentElements = cell.contentElements.map(contentElement =>
                  contentElement.elId === updatedContent.elId ? contentElement : updatedContent
                );
              })
              let updateCell = {...selectedCell,updatedContentElements}
              console.log(updateCell)
              this.cellEditorStoreService.updateSelectedCell(updateCell) */

            })
            break;

          default:
            console.log("Not doing anthing without a valid target - the target: " + this.target)
            break;
        }
        break;

      default:
        console.log("Not doing anything without a service hit - the service: " + this.service)
        break;
    }
  }

}

